var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgDayCoval = _a => {
  var _b;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#172B75"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2133 18.5437C18.224 18.3586 19.1288 17.8154 19.7536 17.0187C20.6096 15.941 21.0449 14.5125 21.0449 12.7206C21.0449 10.9641 20.5237 9.49873 19.48 8.33722C18.9432 7.70403 18.2454 7.21932 17.4564 6.93148L17.209 6.85906V6.10792C17.7067 6.13823 18.2006 6.2114 18.6851 6.32659C19.5028 6.55875 20.2731 6.92722 20.9619 7.41568C22.3158 8.43377 23 9.9957 23 12.0901C23 14.1007 22.3929 15.8203 21.1643 17.236C20.5634 17.9533 19.7671 18.4908 18.8671 18.7865C18.3297 18.9503 17.7765 19.0598 17.2162 19.1131V18.5451L17.2133 18.5437ZM13.389 6.54384V16.9704C13.389 18.0723 14.3571 18.6161 16.3006 18.6161C16.6083 18.6174 16.9156 18.5932 17.2191 18.5437V19.1117C16.5975 19.1728 15.8653 19.2083 15.0457 19.2083H11.6392L11.6261 8.26196C11.6261 7.55199 11.5402 7.08767 11.3539 6.87042C11.1675 6.65317 10.7716 6.54242 10.1732 6.54242H10V6H15.0399C15.8842 6.02414 16.6165 6.05964 17.2133 6.10792V6.85906C16.4927 6.64181 15.5319 6.54384 14.3207 6.54384H13.389Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M20.4407 22.1404H16.0457V26.4272H20.4407V22.1404Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M16.0457 22.1404H11.6391V26.4272H16.0457V22.1404Z",
    fill: "#BBBDBF"
  }));
};
export default SvgDayCoval;